// extracted by mini-css-extract-plugin
module.exports = {"calloutBox":"CalloutBlock_calloutBox__b_Tlx","icon-flex-item":"CalloutBlock_icon-flex-item__ugPVF","img-cell":"CalloutBlock_img-cell__ltGma"};